import React, { useEffect, useState } from 'react';
import Product from '../Product/Product';
import './Products.css'

const Products = () => {
    const [products, setProducts] = useState([]);
    useEffect(() => {
        fetch('https://blooming-refuge-66854.herokuapp.com/products')
            .then(res => res.json())
            .then(data => setProducts(data))
    }, [])
    return (
        <div className="main-container">
            <h1 className="py-5">OUR PRODUCTS</h1>
            <div className="d-flex justify-content-center">
                <div className="products-container">
                    {
                        products.splice(0, 6).map(product => <Product
                            key={product.id}
                            product={product}
                        ></Product>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Products;